/* globals PLUG */

(function (QuantityInput) {

    class PlugQuantityInput extends HTMLElement {
        constructor() {
            super();

            this.input = this.getElementsByTagName("input")[0];
            this.changeEvent = new Event("change", { bubbles: true });

            this.querySelectorAll("button").forEach(
                (button) => button.addEventListener("click", this.onButtonClick.bind(this))
            );
        }

        onButtonClick(event) {
            event.preventDefault();
            const previousValue = this.input.value;
            if (event.target.classList.contains("quantity__button--minus")) {
                this.input.stepDown();
            } else {
                this.input.stepUp();
            }
            if (previousValue !== this.input.value) {
                this.input.dispatchEvent(this.changeEvent);
            }
        }

        hasMax() {
            return (
                this.input.max !== undefined
                && this.input.max !== ""
            );
        }
    }

    customElements.define("plug-quantity-input", PlugQuantityInput);

    QuantityInput.export = function () {
        return Object.freeze({
            // create
        });
    };

})(PLUG.QuantityInput = Object.create(null));
